var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68697 12.131V1.68697H12.15V9.04138L13.837 7.35441V0.834006C13.837 0.360139 13.4579 0 13.003 0H0.834009C0.36014 0 0 0.379093 0 0.834006V12.9839C0 13.4578 0.379095 13.818 0.834009 13.818H7.33549L9.02246 12.131H1.68697Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26886 13.6093L11.4487 15.7891L16.0736 11.1452L13.9128 8.98438L9.26886 13.6093Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8743 8.73829L16.3011 7.16505C16.1305 6.99446 15.8651 6.99446 15.6945 7.16505L14.7468 8.11279L16.9076 10.2736L17.8553 9.32589C18.0449 9.17425 18.0449 8.90888 17.8743 8.73829Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77145 15.1259C7.69563 15.2017 7.65772 15.2965 7.63876 15.3913L7.43026 17.0972C7.39235 17.4005 7.65772 17.6469 7.94204 17.609L9.64797 17.4005C9.74274 17.3815 9.85647 17.3436 9.91333 17.2678L10.5578 16.6233L8.41591 14.4814L7.77145 15.1259Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91848 10.3494C7.39235 10.3494 7.75249 9.97029 7.75249 9.51538V7.75259H9.51528C9.98915 7.75259 10.3493 7.3735 10.3493 6.91859C10.3493 6.46368 9.9702 6.08458 9.51528 6.08458H7.75249V4.3218C7.75249 3.84793 7.37339 3.48779 6.91848 3.48779C6.44461 3.48779 6.08447 3.86689 6.08447 4.3218V6.08458H4.32168C3.84781 6.08458 3.48767 6.46368 3.48767 6.91859C3.48767 7.3735 3.86677 7.75259 4.32168 7.75259H6.08447V9.51538C6.06552 9.97029 6.44461 10.3494 6.91848 10.3494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.9155ff8bb4aaf24f100b8b87e93aaa5b.svg";
export { ForwardRef as ReactComponent };